"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMenuAlunoOnlineItem = exports.yupMenuAlunoOnlineItem = exports.schemaMenuAlunoOnlineSub = exports.yupMenuAlunoOnlineSub = void 0;
const yup = __importStar(require("yup"));
exports.yupMenuAlunoOnlineSub = yup.object({
    id: yup.number().required().label('ID do sub menu'),
    nome: yup.string().required().label('Nome do sub menu'),
    tipo: yup.string().required().label('Tipo do sub menu'),
});
exports.schemaMenuAlunoOnlineSub = exports.yupMenuAlunoOnlineSub.shape({});
exports.yupMenuAlunoOnlineItem = yup.object({
    nome: yup.string().required().label('Nome do menu'),
    motivo: yup.string().notRequired().nullable().default(undefined).label('Motivo do menu estar bloqueado'),
    liberado: yup.boolean().required().default(false).label('Menu liberado'),
});
exports.schemaMenuAlunoOnlineItem = exports.yupMenuAlunoOnlineItem.shape({});
